<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 16 16"
       role="presentation"
       @click="$emit('click')">
    <path :fill="disabled ? disabledStateColor : iconColor" fill-rule="nonzero" d="M1.293 12.707a.997.997 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 1.414L4.414 11H12.5a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H8.988a1 1 0 1 1 0-2H12.5a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3H4.414l1.293 1.293a1 1 0 0 1-1.414 1.414l-3-3z"/>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>
